<script>
import { fb } from '@/lib/common'
export default {
  data: () => ({
    email: '',
    password: ''
  }),
  methods: {
    signIn () {
      fb.auth().signInWithEmailAndPassword(this.email, this.password)
        .then(() => console.log('Sign-in successful'))
        .catch(error => {
          console.error(error)
          alert('ログインできませんでした。')
        })
    }
  }
}
</script>

<template>
  <div class="sign-in">
    <form class="level">
      <input
        type="email"
        placeholder="Mail Address"
        v-model="email"
      >
      <input
        type="password"
        placeholder="Password"
        v-model="password"
      >
      <div class="button">
        <i class="material-icons">login</i>
        <input
          type=submit
          value="サインイン"
          @click.prevent="signIn"
        >
      </div>
    </form>
  </div>
</template>

<style lang="scss" scoped>
.sign-in {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  input {
    margin: .25rem;
  }
  .button {
    padding: 0 .25rem;
    input {
      border: 0;
    }
  }
}
</style>
